import { useState, useEffect } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { useAutoLogout } from "./useAutoLogout";
import { Suspense, lazy } from "react";

// Lazy load all route components to enable code splitting
const MobileNumberScreen = lazy(
  () => import("./component/mobileNumber/mobileNumberScreen")
);
const OtpScreen = lazy(() => import("./component/OtpScreen/otpScreen"));
const SignInGoogle = lazy(
  () => import("./component/signingoogle/signInGoogle")
);
const BeforeAssessment = lazy(
  () => import("./component/beforeAssessment/beforeAssessment")
);
const BeforeAssessment1 = lazy(
  () => import("./component/beforeAssessment/beforeAssessmentoption")
);
const SignupFrom = lazy(() => import("./component/signupForm/signupFrom"));
const CourseStartPage = lazy(
  () => import("./component/coursepage/courseStartPage")
);
const CoursePage = lazy(() => import("./component/coursepage/coursePage"));
const Coursedescpage = lazy(
  () => import("./component/coursepage/coursedescpage")
);
const CourseMaterial = lazy(
  () => import("./component/courseMaterials/CourseMaterial")
);
const Notificationpage = lazy(
  () => import("./component/notification/notificationpage")
);
const NotificationDetails = lazy(
  () => import("./component/notification/notificationDetails")
);
const SearchCourse = lazy(
  () => import("./component/searchCourse/searchCourse")
);
const AllcoursePage = lazy(
  () => import("./component/searchCourse/allcoursePage")
);
const ProfilePage = lazy(() => import("./component/myProfile/profile"));
const Appliedjob = lazy(() => import("./component/applyJob/applyjob"));
const AppliedJobDesc = lazy(
  () => import("./component/applyJob/appliedJobDesc")
);
const Allocatedcourse = lazy(
  () => import("./component/beforeAssessment/allocatedcourse")
);
const Latestjob = lazy(() => import("./component/latestjob/latestjob"));
const Latestjobdesc = lazy(() => import("./component/latestjob/latestjobdesc"));
const Homepage = lazy(() => import("./component/homepage/homepage"));
const VerifyEmail = lazy(() => import("./component/signupForm/verifyEmail"));
const ResourcePage = lazy(() => import("./component/Resources/ResourcePage"));
const ResourceDetail = lazy(
  () => import("./component/Resources/ResourceDetail")
);
const TrendingCourse = lazy(
  () => import("./component/searchCourse/trendingCourse")
);
const TechnologiesCourse = lazy(
  () => import("./component/searchCourse/technologiesCourse")
);
const CourseDetialed = lazy(
  () => import("./component/searchCourse/courseDetailes")
);
const FreeTrendingCourse = lazy(
  () => import("./component/freeCourse/FreetrendingCourse")
);
const FreeTechnologiesCourse = lazy(
  () => import("./component/freeCourse/FreetechnologiesCourse")
);
const FreeCourseDetialed = lazy(
  () => import("./component/freeCourse/FreecourseDetailes")
);
const FreeCoursePage = lazy(
  () => import("./component/freeCourse/FreeCoursePage")
);
const AllFreecoursePage = lazy(
  () => import("./component/freeCourse/allFreecoursePage")
);
const CourseVideo = lazy(
  () => import("./component/FreeCourseVideo/courseVideo")
);
const RequestCertificate = lazy(
  () => import("./component/FreeCourseVideo/RequestCertificate")
);
const SingleVideo = lazy(
  () => import("./component/FreeCourseVideo/singleVideo")
);
const TrainerLogin = lazy(() =>
  import("./component/TrainerModule/pages/TrainerLogin").then((module) => ({
    default: module.TrainerLogin,
  }))
);
const TrainerLayout = lazy(
  () => import("./component/TrainerModule/TrainerLayout")
);
const ProtectedRoute = lazy(() => import("./ProtectedRoute"));

function App() {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  // Custom hook for auto logout
  useAutoLogout();

  return (
    <div className="App font-[roboto]">
      {/* Toaster for notifications */}
      <Toaster />
      {!isOnline && <OfflineIndicator />}

      {/* Wrap all routes in Suspense for lazy loading */}
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {/* Public Routes */}
          <Route path="/otp-screen" element={<OtpScreen />} />
          <Route path="/sign-in-google" element={<SignInGoogle />} />
          <Route path="/signup-from" element={<SignupFrom />} />
          <Route path="/verifyemail" element={<VerifyEmail />} />
          <Route path="/" element={<MobileNumberScreen />} />

          {/* Add Trainer Login Route - PUBLIC ROUTE */}
          <Route path="/trainer/login" element={<TrainerLogin />} />

          {/* Protected Routes */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Routes>
                  {/* Assessment Routes */}
                  <Route
                    path="/beforeassessment"
                    element={<BeforeAssessment />}
                  />
                  <Route
                    path="/beforeassessment1"
                    element={<BeforeAssessment1 />}
                  />

                  {/* Course Routes */}
                  <Route path="/home" element={<Homepage />} />
                  <Route
                    path="/course-start-page"
                    element={<CourseStartPage />}
                  />
                  <Route path="/course-page" element={<CoursePage />} />
                  <Route path="/course-descpage" element={<Coursedescpage />} />
                  <Route path="/course-material" element={<CourseMaterial />} />
                  <Route path="/all-coursepage" element={<AllcoursePage />} />
                  <Route path="/search-course" element={<SearchCourse />} />
                  <Route path="/trending-course" element={<TrendingCourse />} />
                  <Route
                    path="/technologies-course/:id"
                    element={<TechnologiesCourse />}
                  />
                  <Route path="/course/:id" element={<CourseDetialed />} />
                  <Route path="/course-video" element={<CourseVideo />} />

                  {/* Free Course Routes */}
                  <Route
                    path="/all-free-coursepage"
                    element={<AllFreecoursePage />}
                  />
                  <Route path="/free-Coursepage" element={<FreeCoursePage />} />
                  <Route
                    path="/free-trending-course"
                    element={<FreeTrendingCourse />}
                  />
                  <Route
                    path="/free-technologies-course/:id"
                    element={<FreeTechnologiesCourse />}
                  />
                  <Route
                    path="/free-course-details/:id"
                    element={<FreeCourseDetialed />}
                  />

                  {/* Notification Routes */}
                  <Route
                    path="/notificationpage"
                    element={<Notificationpage />}
                  />
                  <Route
                    path="/notificationdetails"
                    element={<NotificationDetails />}
                  />

                  {/* Resource Routes */}
                  <Route path="/resource" element={<ResourcePage />} />
                  <Route path="/resourses/:id" element={<ResourceDetail />} />

                  {/* Profile & Job Routes */}
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/profile/:subroute" element={<ProfilePage />} />
                  <Route path="/applied-job" element={<Appliedjob />} />
                  <Route path="/appliedjobdesc" element={<AppliedJobDesc />} />
                  <Route
                    path="/allocatedcourse"
                    element={<Allocatedcourse />}
                  />
                  <Route path="/latestjob" element={<Latestjob />} />
                  <Route path="/latestjobdesc" element={<Latestjobdesc />} />

                  {/* Certificate */}
                  <Route
                    path="/request-certificate"
                    element={<RequestCertificate />}
                  />

                  {/* Videos */}
                  <Route path="/single-videos" element={<SingleVideo />} />

                  {/* Trainer Routes */}
                  <Route path="/trainer/:page" element={<TrainerLayout />} />
                </Routes>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;

const OfflineIndicator = () => {
  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="relative">
        <div className="flex items-start gap-3">
          <div className="w-64 bg-white dark:bg-gray-800 rounded-lg shadow-xl p-3 border border-gray-200 dark:border-gray-700">
            <div className="text-sm text-gray-700 dark:text-gray-200">
              <p className="font-medium">Connection lost</p>
              <p className="mt-1">
                We'll automatically reconnect when you're back online
              </p>
              <div className="mt-2 h-1 w-full bg-gray-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-red-500 animate-pulse"
                  style={{ width: "30%" }}
                />
              </div>
            </div>
          </div>

          {/* Indicator circle */}
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-red-500 to-red-700 shadow-lg flex items-center justify-center cursor-pointer transform transition-all hover:scale-105 active:scale-95">
            <svg
              className="w-8 h-8 text-white animate-pulse"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M5.636 5.636l3.536 3.536m0 5.656l-3.536 3.536"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};
